export default "__VITE_ASSET__GtRmgTNW__"